<template>
  <div class="colloque-wrap">
    <div class="container mx-auto px-6">

      <h2 class="text-3xl font-bold text-center mb-8 text-yellow-700 uppercase">
        Colloque International : Religions, Politique et Développement
      </h2>

      <div class="content-text">
        <p class="mb-4">
          Du 1er au 3 février 2019, à Cotonou, à Bénin Marina Hôtel et à Espace Antou, près de 300 personnes 
          sans compter les 150 élèves ayant participé à la cérémonie d’ouverture, ont célébré le 1er anniversaire 
          de l’Ecole et rendu hommage à l’éminent serviteur de l’Eglise et de la République qu’est Mgr Isidore de Souza.
        </p>

        <p class="mb-4">
          Le colloque a été enrichi, le dernier jour, par une visite pèlerinage en la ville natale du prélat, Ouidah, 
          en divers parcours relatifs à sa vie : Place Chacha, Porte du Non-retour, Porte du Salut, Basilique Immaculée Conception, 
          Fort Français, Grand séminaire Saint-Gall où la messe d’Action de grâce fut célébrée par Mgr Roger Houngbédji, 
          archevêque de Cotonou et Centre Catéchétique (pour la restauration). 
        </p>

        <p class="mb-4">
          Des textes significatifs de Mgr Isidore de Souza ont été lus en divers lieux et certaines de ses photos exposées. 
          Et à la Cathédrale Notre Dame de Miséricorde de Cotonou où il repose, une gerbe de fleurs a été déposée sur sa tombe. 
          Le discours de fin du colloque y fut prononcé par le Père Rodrigue Gbédjinou. 
          Un manifeste du colloque, adopté le 2 février, indique les divers axes d’action et d’application des travaux du colloque. 
          Il fut rendu public le 13 mars 2019 à l’EITP, jour d’incidence des 20 ans du décès de Mgr Isidore de Souza.
        </p>

        <!-- Images du colloque -->
        <!--
        <div class="grid md:grid-cols-3 gap-4 text-center mb-6">
          <img src="@/assets/images/DSC_0192.jpg" alt="DSC 0192" class="rounded shadow-md"/>
          <img src="@/assets/images/DSC_0351.jpg" alt="DSC 0351" class="rounded shadow-md"/>
          <img src="@/assets/images/DSC_0164.jpg" alt="DSC 0164" class="rounded shadow-md"/>
          <img src="@/assets/images/DSC_0355.jpg" alt="DSC 0355" class="rounded shadow-md"/>
          <img src="@/assets/images/DSC_0211.jpg" alt="DSC 0211" class="rounded shadow-md"/>
          <img src="@/assets/images/DSC_0177.jpg" alt="DSC 0177" class="rounded shadow-md"/>
          <img src="@/assets/images/DSC_0163.jpg" alt="DSC 0163" class="rounded shadow-md"/>
          <img src="@/assets/images/DSC_0098.jpg" alt="DSC 0098" class="rounded shadow-md"/>
          <img src="@/assets/images/DSC_0105.jpg" alt="DSC 0105" class="rounded shadow-md"/>
          <img src="@/assets/images/DSC_0110.jpg" alt="DSC 0110" class="rounded shadow-md"/>
          <img src="@/assets/images/DSC_0102.jpg" alt="DSC 0102" class="rounded shadow-md"/>
          <img src="@/assets/images/DSC_0085.jpg" alt="DSC 0085" class="rounded shadow-md"/>
        </div>
        -->
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ColloqueDetails",
  setup() {
    return {};
  },
});
</script>

<style scoped>
.colloque-wrap {
  background-color: #fff;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

h2 {
  color: #2b3a67;
}

.content-text p {
  margin-bottom: 1rem;
}

.content-text ul {
  list-style-type: disc;
  padding-left: 1.5rem;
  line-height: 1.8;
}

img {
  max-width: 100%;
}
</style>
